export default __webpack_public_path__ + "static/media/spin-bg-19.a8da2fc3.png";